import React, { useContext, useEffect, useState } from "react";
import Success from "../../../../components/Multiple/Success";
import Negotiate from "../../../../components/Multiple/Negotiate";
import DeclinedDelivery from "../../../../components/Multiple/DeclinedDelivery";
import { TiThMenu } from "react-icons/ti";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import { useParams } from "react-router-dom";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import SocketContext from "../../../../Context/Socket/SocketContext";
import {
  formatDateandtime,
  formatDateForInput,
  getFileNameFromUrl,
  getfileTypefromurl,
  OfferStep,
} from "../../../../Files/UseFunction";
import {
  FaDownload,
  FaFileAlt,
  FaFileImage,
  FaFileVideo,
  FaRegFilePdf,
  FaTimes,
} from "react-icons/fa";
import { BsFiletypeDocx } from "react-icons/bs";
import { MdFolderZip } from "react-icons/md";
import axios from "axios";
import PayOffer from "../../../../components/Multiple/PayOffer";
import DeliverPopup from "../../../../components/PopUp/DeliverPopup";
import NegotiateMessage from "../../../../components/Multiple/NegotiateMessage";
import io from "socket.io-client";
import ReviewPopup from "../../../../components/PopUp/ReviewPopup";
import ScrollToBottom from "react-scroll-to-bottom";
import DeclinedBuyerDelivery from "../../../../components/Multiple/DeclinedBuyerDelivery";

const scrollbarHideStyle = {
  msOverflowStyle: "none",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const RecivedChat = () => {
  const [OrderStatus, setOrderStatus] = useState(false);
  const [OfferDetails, setOfferDetails] = useState(null);
  const [Steps, setSteps] = useState([]);
  const [message, setmessage] = useState("");
  const [ChatFile, setChatFile] = useState(null);
  const [FileName, setFileName] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);
  const [Conversation, setConversation] = useState([]);
  const [TotalPages, setTotalPages] = useState(null);
  const [Page, setPage] = useState(null);
  const [PayService, setPayService] = useState(false);
  // const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [shouldRevBtnVisble, setShouldRevBtnVisble] = useState(true);

  const { recivedid } = useParams();

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;
  const { theme } = useContext(ThemeContext);

  const socketcontext = useContext(SocketContext);
  const { OnlineUsers, SocetConnection, isUserOnline, setSocetConnection } =
    socketcontext;
  const [isReviewPopupVisible, setIsReviewPopupVisible] = useState(false);

  const reviewed = async () => {
    try {
      const response = await axios.get(
        `${BaseURL}/api/review/isReviewed/${recivedid}`,
        {
          headers: {
            "auth-token": localStorage.getItem("p@token"),
          },
        }
      );

      if (response.data.isReviewed) {
        setShouldRevBtnVisble(!response.data.isReviewed);
      }
    } catch (error) {
      console.error("Review Error:", error);
    }
  };

  const btnOffer = async (status) => {
    try {
      if (status === "Completed") {
        const authToken = localStorage.getItem("p@token");

        const response = await axios.post(
          `${BaseURL}/api/getusers/balance`,
          { offerId: recivedid },
          {
            headers: {
              "auth-token": authToken,
              "Content-Type": "application/json",
            },
            body: {
              offerId: recivedid,
            },
          }
        );
        if (!response) {
          showAlert("Unsuccessful", "danger");
          return;
        }
      }
      SocetConnection.emit("updateStatus", {
        status: status,
        offerId: recivedid,
      });
    } catch (error) {
      showAlert("Failed", "danger");
      console.error("Accept Offer Error:", error);
    }
  };

  const fetchconversation = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/offermessage/getMessages/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setConversation(response.data.messages);
        setTotalPages(response.data.totalPages);
        setPage(response.data.page);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const updateSeenChat = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/offermessage/markAsSeen/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.ok) {
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const fetchOffer = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(
        `${BaseURL}/api/recivedoffers/recivedoffer/${recivedid}`,
        {
          method: "GET",
          headers: {
            "auth-token": authToken,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        showAlert(`${data.message}`, "danger");
        return;
      }
      setOfferDetails(data.offer);
      const OfferStepReturn = OfferStep(data.offer.Status);
      setSteps(OfferStepReturn);
    } catch (error) {
      showAlert("Failed to fetch offer details", "danger");
    }
  };

  useEffect(() => {
    if (recivedid) {
      fetchOffer();
      fetchconversation(recivedid);
      updateSeenChat(recivedid);
      paymentProceed(recivedid);
      reviewed();
    }
  }, [recivedid]);

  useEffect(() => {
    if (SocetConnection) {
      const handleMessage = (data) => {
        if (recivedid) {
          fetchconversation(recivedid);
          updateSeenChat(recivedid);
        }
      };

      const handleUpdateStatus = () => {
        fetchOffer();
      };

      const handleNegotiation = () => {
        fetchOffer();
      };

      // Attach the event handler
      SocetConnection.on("offermessage", handleMessage);
      SocetConnection.on("updateStatus", handleUpdateStatus);
      SocetConnection.on("Negotiation", handleNegotiation);

      // Cleanup function to remove the event handler
      return () => {
        SocetConnection.off("offermessage", handleMessage);
        SocetConnection.off("updateStatus", handleUpdateStatus);
        SocetConnection.off("Negotiation", handleNegotiation);
      };
    }
  }, [SocetConnection]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    const userid = OfferDetails?.Seller?._id;

    if (userid) {
      if (message !== "") {
        if (SocetConnection) {
          SocetConnection.emit("new offer message", {
            Offer_id: recivedid,
            UserID: userid,
            covnersation: message,
            File: {
              Link: UploadedFile,
              Name: FileName,
            },
          });
          setmessage("");
          setUploadedFile(null);
          setFileName(null);
          setChatFile(null);
        }
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendMessage(e);
    }
  };

  const FileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      setChatFile(file);
      setFileName(file.name);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", file.name);

      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/offermessage/upload-docs`, {
        method: "POST",
        headers: {
          "auth-token": authToken,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setUploadedFile(data?.location);
      } else {
        showAlert("File not uploaded, try again", "danger");
      }
    } catch (error) {
      console.error("File upload error:", error);
      showAlert("File not uploaded, try again", "danger");
    }
  };

  const renderFileIcon = (file) => {
    const fileType = file;

    switch (fileType) {
      case "image":
        return <FaFileImage className="text-2xl w-full text-primarygreen" />;
      case "video":
        return <FaFileVideo className="text-2xl w-full text-primarygreen" />;
      case "pdf":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "application":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "doc":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "docx":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "zip":
        return <MdFolderZip className="text-2xl w-full text-gray-400" />;
      default:
        return <FaFileAlt className="text-2xl w-full text-primarygreen" />;
    }
  };

  const declineOffer = async (offerId) => {
    try {
      SocetConnection.emit("updateStatus", {
        status: "Declined",
        offerId: recivedid,
      });
    } catch (error) {
      showAlert(
        error.response?.data?.message || "Failed to decline the offer",
        "danger"
      );
    }
  };

  const paymentProceed = async (offerId) => {
    const authToken = localStorage.getItem("p@token");
    const status = await fetch(
      `${BaseURL}/api/payment/pay/order-status/${offerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      }
    );
    const statusRes = await status.json();
    const orderId = statusRes.orderid;

    if (statusRes.status === "APPROVED") {
      const captureResponse = await fetch(
        `${BaseURL}/api/payment/pay/capture-payment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
          body: JSON.stringify({
            orderId: orderId,
            recivedid: recivedid,
          }),
        }
      );
      if (!captureResponse.ok) {
        return;
      }

      if (captureResponse.ok) {
        const socketConnection = io(BaseURL, {
          auth: {
            token: authToken,
          },
        });
        setSocetConnection(socketConnection);
        if (socketConnection)
          socketConnection.emit("updateStatus", {
            status: "In progress",
            offerId: recivedid,
          });
        else console.log("Socket Connection does not exist");

        showAlert("Transaction completed successfully", "success");
      }
    }
  };

  return (
    <div className="min-h-full overflow-hidden">
      {PayService && <PayOffer setPayService={setPayService} />}
      {isReviewPopupVisible && (
        <ReviewPopup
          setIsReviewPopupVisible={setIsReviewPopupVisible}
          userId={OfferDetails.Seller._id}
          offerId={OfferDetails._id}
          reviewBtn={setShouldRevBtnVisble}
        />
      )}
      <div className="bg-white font-pop w-full px-2 md:px-6 py-2">
        <div className="flex flex-row md:flex-row justify-between md:items-center">
          <div className="flex flex-row gap-4 items-center">
            {OfferDetails?.Seller?.ProfilePhoto ? (
              <div className="relative rounded-full w-8 md:w-12 h-8 md:h-12">
                <img
                  src={OfferDetails?.Seller?.ProfilePhoto}
                  alt=""
                  className="w-full h-full object-cover rounded-full"
                />
                {isUserOnline(OfferDetails?.Seller?._id) && (
                  <div className="bg-primarygreen rounded-full h-3 w-3 absolute bottom-1 -right-1"></div>
                )}
              </div>
            ) : (
              <div
                className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop  flex items-center justify-center ${
                  theme == "dark" ? "bg-black text-white" : "bg-gray-400 "
                }`}
              >
                <span className="text-white">
                  {OfferDetails?.Seller?.FirstName &&
                    OfferDetails?.Seller?.FirstName?.charAt(0)}
                </span>
              </div>
            )}
            <div className="flex flex-col">
              <h2 className="text-sm md:text-lg font-semibold">
                {OfferDetails?.Seller?.FirstName}{" "}
                {OfferDetails?.Seller?.LastName}
              </h2>
              <p className="text-xs md:text-base text-gray-400">
                {isUserOnline(OfferDetails?.Seller?._id) ? (
                  <span className="text-primarygreen">Online</span>
                ) : (
                  "Offline"
                )}
              </p>
            </div>
          </div>
          <div className="flex flex-row gap-2 items-center">
            <div className="flex flex-row gap-2 items-center">
              {OfferDetails?.Status == "New" ? (
                <>
                  <button
                    className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
                    onClick={() => {
                      setPayService(true);
                    }}
                  >
                    Accept
                  </button>
                  <button
                    className="my-4 w-fit px-2 md:px-6 bg-transparent hover:bg-primarygreen text-black hover:text-white font-semibold font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full "
                    onClick={() => {
                      declineOffer(recivedid);
                    }}
                  >
                    Decline
                  </button>
                </>
              ) : (
                OfferDetails?.Status === "Delivered" && (
                  <>
                    <button
                      className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 hover:text-black font-pop text-sm md:text-md py-1 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white"
                      onClick={() => btnOffer("Completed")}
                    >
                      Accept delivery
                    </button>
                    <button
                      className="my-4 w-fit px-2 md:px-6 hover:bg-green-500  bg-white-500  hover:text-white font-pop text-sm md:text-md py-1 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-black"
                      onClick={() => btnOffer("Under review")}
                    >
                      Negotiate delivery
                    </button>
                    <button
                      className="my-4 w-fit px-2 md:px-6 hover:bg-green-500  bg-white-500  hover:text-white font-pop text-sm md:text-md py-1 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-black"
                      onClick={() => btnOffer("Declining")}
                    >
                      Decline delivery
                    </button>
                  </>
                )
              )}
              {OfferDetails?.Status === "Completed" && shouldRevBtnVisble && (
                <button
                  className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
                  onClick={() => setIsReviewPopupVisible(true)}
                >
                  Give Review
                </button>
              )}
            </div>
            <TiThMenu
              className="text-xl block lg:hidden"
              onClick={() => {
                setOrderStatus(true);
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row min-h-full basis-[100%] h-max">
        <div className="basis-[100%] lg:basis-[70%] font-pop px-6 py-4 min-h-full">
          <div className="flex flex-col gap-6 h-[100%] justify-between">
            <ScrollToBottom className="flex flex-col gap-2 scrollbar-hide">
              <div className="h-[calc(100vh-300px)] scrollbar-hide">
                <div className="flex flex-col gap-2">
                  {Conversation?.length > 0 &&
                    Conversation?.map((item, index) => (
                      <div
                        key={index}
                        className={`${
                          item.tag === "Sender"
                            ? "flex flex-col justify-end"
                            : "flex flex-col justify-start"
                        } my-1 gap-1`}
                      >
                        {item?.File?.Link && (
                          <div
                            className={`p-2 rounded w-fit shadow-md font-pop flex items-end ${
                              item.tag === "Sender"
                                ? "bg-primarygreen/50 self-end text-white"
                                : "bg-gray-300"
                            }`}
                          >
                            <div className="flex flex-col gap-2">
                              {item?.File && renderFileIcon(item?.File?.Link)}
                              <span className="ml-2 truncate max-w-[200px]">
                                {item?.File?.Name}
                              </span>
                            </div>
                            <a
                              href={item?.File?.Link}
                              download={true}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaDownload className="ml-2 text-3xl text-gray-500 cursor-pointer" />
                            </a>
                          </div>
                        )}
                        {item?.CreatedBY === "SystemNegotiationAccept" ? (
                          <></>
                        ) : item?.CreatedBY === "SystemNegotiation" ? (
                          <NegotiateMessage
                            Seller={true}
                            Message={item?.message}
                          />
                        ) : item?.CreatedBY === "SystemDeclineDelivery" ? (
                          <DeclinedDelivery
                            item={item?.message}
                            offer={recivedid}
                          />
                        ) : item?.CreatedBY === "System" ? (
                          <Success />
                        ) : (
                          <div
                            className={`${
                              item.tag === "Sender"
                                ? "bg-primarygreen self-end text-white"
                                : "bg-[#E8E8E8]"
                            } rounded-xl py-2 px-3 max-w-xs w-fit`}
                            style={{ wordBreak: "break-word" }}
                          >
                            <p className="text-sm md:text-base">
                              {item?.message}
                            </p>
                          </div>
                        )}
                        {item.CreatedBY !== "System" &&
                          item.CreatedBY !== "SystemNegotiation" &&
                          item?.CreatedBY !== "SystemNegotiationAccept" && (
                            <p
                              className={`${
                                item.tag === "Sender"
                                  ? "text-right"
                                  : "text-left"
                              } text-xs`}
                            >
                              {formatDateForInput(item?.date)}
                            </p>
                          )}
                      </div>
                    ))}
                  {OfferDetails?.Status === "Under review" && (
                    <Negotiate Buyer={true} />
                  )}
                  {OfferDetails?.Status === "Declining" && (
                    <DeclinedBuyerDelivery btnOffer={btnOffer} />
                  )}
                </div>
              </div>
            </ScrollToBottom>
            <div className="flex flex-row font-pop justify-between items-center bg-[#E8E8E9] rounded-2xl py-1 md:py-2 px-2 md:px-4">
              <div className="flex w-[100%] flex-row items-center gap-2">
                <label htmlFor="fileupload" className="relative cursor-pointer">
                  <img
                    src="../../../../Assets/Prop/docattach.png"
                    alt=""
                    className="w-8 h-8"
                  />
                  <input
                    type="file"
                    id="fileupload"
                    onChange={FileUpload}
                    className="hidden"
                  />
                </label>
                <div className="flex gap-2 w-full">
                  {UploadedFile !== "" && UploadedFile !== null && (
                    <div className="bg-gray-300 p-2 rounded shadow-md font-pop flex items-center">
                      <div className="flex flex-col gap-2">
                        {ChatFile && renderFileIcon(ChatFile)}
                        <span className="ml-2 w-max text-xs">{FileName}</span>
                      </div>
                      <FaTimes
                        className="ml-2 text-red-500 cursor-pointer"
                        onClick={() => {
                          setChatFile(null);
                          setFileName(null);
                          setUploadedFile(null);
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => setmessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Message..."
                    className="text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent"
                  />
                </div>
              </div>
              <img
                src="/Assets/Prop/messagesend.png"
                alt=""
                onClick={handleSendMessage}
                className="w-4 h-4 md:w-8 md:h-8 cursor-pointer"
              />
            </div>
          </div>
        </div>
        <div
          className={`lg:basis-[30%] left-0 top-0 w-[100vw] h-[100vh] lg:w-[100%] lg:h-[calc(100vh-160px)] fixed lg:relative z-50 ${
            OrderStatus == true ? "block" : "hidden lg:block"
          } font-pop `}
        >
          <div
            className="absolute bg-black/50 block lg:hidden w-[100vw] h-[100vh] z-30"
            onClick={() => {
              setOrderStatus(false);
            }}
          ></div>
          <div className="py-4 px-6 bg-white max-w-[90%] lg:max-w-full max-h-[80vh] lg:max-h-full mt-16 lg:mt-0 overflow-y-auto h-fit lg:h-full rounded-xl lg:rounded-none relative z-40 flex flex-col gap-4 justify-center lg:justify-start items-center m-auto">
            <div className="border-2 border-[#E9E9E9] w-full rounded-2xl py-4 px-4">
              <div className="flex justify-between">
                <div className="flex flex-col gap-2">
                  <div
                    className={`
                                        py-2 px-4 rounded-lg border-2 w-fit font-medium 
                                        ${
                                          OfferDetails?.Status === "New"
                                            ? "bg-[#8A39F2]/30 border-[#8A39F2] text-[#8A39F2]"
                                            : OfferDetails?.Status ===
                                              "In progress"
                                            ? "bg-[#EBF4FE] border-[#3992F2] text-[#3992F2]"
                                            : OfferDetails?.Status ===
                                              "Delivered"
                                            ? "bg-[#FCEBFE] border-[#E339F2] text-[#E339F2]"
                                            : OfferDetails?.Status ===
                                              "Completed"
                                            ? "bg-[#EFFBF1] border-[#63D577] text-[#63D577]"
                                            : OfferDetails?.Status ===
                                              "Under review"
                                            ? "bg-[#FEF8EE] border-[#F9B754] text-[#F9B754]"
                                            : "bg-[#FCEBEC] border-[#DD3242] text-[#DD3242]"
                                        }`}
                  >
                    {OfferDetails?.Status}
                  </div>
                  <h2 className="text-lg font-semibold">
                    {OfferDetails?.Type}
                  </h2>
                </div>
                <div className="flex flex-col gap-2">
                  <p className="text-sm text-gray-400">
                    {formatDateandtime(OfferDetails?.date)}
                  </p>
                  <p className="font-medium text-primarygreen">
                    ${OfferDetails?.Price}
                  </p>
                </div>
              </div>
              <p className="font-medium">{OfferDetails?.Type}</p>
            </div>
            <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
              <p className="text-lg text-gray-400">Seller</p>
              <div className="flex flex-row gap-2 items-center">
                {OfferDetails?.Seller?.ProfilePhoto ? (
                  <div className="relative rounded-full w-8 md:w-12 h-8 md:h-12">
                    <img
                      src={OfferDetails?.Seller?.ProfilePhoto}
                      alt=""
                      className="w-full h-full object-cover rounded-full"
                    />
                    {isUserOnline(OfferDetails?.Seller?._id) && (
                      <div className="bg-primarygreen rounded-full h-3 w-3 absolute bottom-1 -right-1"></div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop  flex items-center justify-center ${
                      theme == "dark" ? "bg-black text-white" : "bg-gray-400 "
                    }`}
                  >
                    <span className="text-white">
                      {OfferDetails?.Seller?.FirstName &&
                        OfferDetails?.Seller?.FirstName?.charAt(0)}
                    </span>
                  </div>
                )}
                <h2 className="font-semibold">
                  {OfferDetails?.Seller?.FirstName}{" "}
                  {OfferDetails?.Seller?.LastName}
                </h2>
              </div>
            </div>
            <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
              <p className="text-lg text-gray-400">Attached files</p>
              <div className="flex flex-col gap-2">
                {OfferDetails?.FileAttached?.map((item, index) => (
                  <a
                    href={item.src}
                    target="_blank"
                    download={true}
                    className="flex flex-row gap-2 items-center"
                    key={index}
                  >
                    <img
                      src={
                        getfileTypefromurl(item.src) == "pdf"
                          ? "../../../Assets/Prop/pdf.png"
                          : "../../../Assets/Prop/IDIcon.png"
                      }
                      alt=""
                      className="w-8 h-8"
                    />
                    <h2 className="font-semibold">
                      {getFileNameFromUrl(item.src)}
                    </h2>
                  </a>
                ))}
              </div>
            </div>
            <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
              <p className="text-lg text-gray-400">Offer timeline</p>
              <div className="flex flex-col gap-1">
                {Steps?.map((step, i) => (
                  <div
                    className="flex flex-row items-center justify-between"
                    key={i}
                  >
                    <div className="flex flex-row gap-2 items-center">
                      <img
                        src="../../../Assets/Prop/tick.png"
                        alt=""
                        className="w-6 h-6"
                      />
                      <h2 className="font-semibold">{step.stage}</h2>
                    </div>
                    <p className="text-lg text-gray-400">04 Dec</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecivedChat;
